import { StatusId, OperationMS, CommandeMS } from '../types';
import { isAnalyseValidee } from './analyse/historique';

// Gating de l'onglet Messagerie privee (acheteur MS), PAR id de statut. La fenetre d'envoi
// de TabMessagerie (Q&R/messagerie) sera unifiee ici quand on cablera la case prestataire.

// Candidatures "valides" : ni refusees (6) ni expirees (12) — filtrees PAR id_status.
// Process MS : non-retenu -> 6 Refuser, sans reponse -> 12 Expirer. (L'ancienne page excluait
// 8 par erreur, croyant 8=refus ; corrige ici d'apres le vrai process.)
export const prestatairesValides = (operation: OperationMS): CommandeMS[] =>
  (operation.commandes || []).filter(
    (c) => c.id_status !== StatusId.Refuser && c.id_status !== StatusId.Expirer,
  );

// L'onglet Messagerie (prive) est-il GRISE ? Acheteur MS uniquement, PAR id de statut :
// disponible une fois le marche signe (Valider=11) + au moins un prestataire valide + garde
// annulation. (La logique cote prestataire vivra dans la future case presta `commande-ms`.)
export const messagerieOngletDisabled = (operation: OperationMS): boolean => {
  const sid = operation.status?.id;
  const hasValidPrestataires = prestatairesValides(operation).length > 0;
  const analyseStarted = isAnalyseValidee(operation.historique);
  const isSigned = sid === StatusId.Valider; // 11
  const isAnnule = sid === StatusId.Annule; // 14
  return !isSigned || !hasValidPrestataires || (isAnnule && !analyseStarted);
};
